import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/auth';
import Sidebar from './components/Sidebar';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import UploadPage from './pages/UploadPage';
import CashTransactionsPage from './pages/CashTransactionsPage';
import TransactionsPage from './pages/TransactionsPage';
import ForecastPage from './pages/ForecastPage';
import ScenariosPage from './pages/ScenariosPage';
import InvestmentsPage from './pages/InvestmentsPage';
import ReconciliationPage from './pages/ReconciliationPage';
import CategoriesPage from './pages/CategoriesPage';
import IncomePage from './pages/IncomePage';
import LoansPage from './pages/LoansPage';
import NetWorthPage from './pages/NetWorthPage';
import ReportsPage from './pages/ReportsPage';
import HouseholdPage from './pages/HouseholdPage';
import IouPage from './pages/IouPage';
import './index.css';

function Layout({ children }) {
  const token = useAuthStore(s => s.token) || localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return (
    <div className="layout">
      <Sidebar />
      <main className="main">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#fff',
            color: '#2a2825',
            border: '1px solid #e8e4de',
            fontFamily: "'Geist', sans-serif",
            fontSize: 13,
            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
          },
          success: { iconTheme: { primary: '#2d7a4f', secondary: '#fff' } },
          error:   { iconTheme: { primary: '#b83232', secondary: '#fff' } },
        }}
      />
      <Routes>
        <Route path="/login" element={<AuthPage />} />
        <Route path="/"               element={<Layout><Dashboard /></Layout>} />
        <Route path="/upload"         element={<Layout><UploadPage /></Layout>} />
        <Route path="/cash"           element={<Layout><CashTransactionsPage /></Layout>} />
        <Route path="/transactions"   element={<Layout><TransactionsPage /></Layout>} />
        <Route path="/forecast"       element={<Layout><ForecastPage /></Layout>} />
        <Route path="/scenarios"      element={<Layout><ScenariosPage /></Layout>} />
        <Route path="/investments"    element={<Layout><InvestmentsPage /></Layout>} />
        <Route path="/reconciliation" element={<Layout><ReconciliationPage /></Layout>} />
        <Route path="/categories"     element={<Layout><CategoriesPage /></Layout>} />
        <Route path="/income"         element={<Layout><IncomePage /></Layout>} />
        <Route path="/loans"          element={<Layout><LoansPage /></Layout>} />
        <Route path="/networth"       element={<Layout><NetWorthPage /></Layout>} />
        <Route path="/reports"        element={<Layout><ReportsPage /></Layout>} />
        <Route path="/household"      element={<Layout><HouseholdPage /></Layout>} />
        <Route path="/iou"            element={<Layout><IouPage /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}
